import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FiUpload, FiTrash2, FiSave } from "react-icons/fi";
import { useDropzone } from "react-dropzone";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingFooterCompanyLogo = () => {
  const [logo, setLogo] = useState(null);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  useEffect(() => {
    fetchLogo();
  }, []);

  // ✅ AYARLARI /api/settings/1 den çekiyoruz
  const fetchLogo = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/settings/1`);

      if (res.data.footer_company_logo) {
        setLogo({
          preview: `${BASE_URL}${res.data.footer_company_logo}`,
        });
      } else {
        setLogo(null);
      }
    } catch (err) {
      toast.error(getText("LOGO_FETCH_ERROR"));
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setLogo(Object.assign(file, { preview: URL.createObjectURL(file) }));
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    maxFiles: 1,
  });

  const removeLogo = () => setLogo(null);

  // ✅ UPLOAD route'u düzeltildi
  const handleSave = async () => {
    try {
      if (!logo || !(logo instanceof File)) {
         toast.info(getText("NO_NEW_LOGO_SELECTED"));
        return;
      }

      const fd = new FormData();
      fd.append("logo", logo);

      await axios.post(`${BASE_URL}/api/settings/footerCompanyLogo/upload`, fd);

      toast.success( getText(
          "FOOTER_LOGO_UPDATED_SUCCESS"
        ));
      fetchLogo();
    } catch (err) {
      getText("FOOTER_LOGO_UPLOAD_ERROR")
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <div className="content-area-body">
          <div className="card">
            <div className="card-body">
              <label className="form-label fw-bold mb-2">
                {getText("FOOTER_COMPANY_LOGO_LABEL")}
              </label>

              <div
                {...getRootProps()}
                style={{
                  border: "2px dashed #0d6efd",
                  padding: 30,
                  borderRadius: 10,
                  textAlign: "center",
                  cursor: "pointer",
                  background: isDragActive ? "#eef5ff" : "#fafafa",
                }}
              >
                <input {...getInputProps()} />

                {!logo ? (
                  <>
                    <FiUpload size={32} className="text-primary" />
                    <p className="mt-2 mb-0"> {getText(
                        "CLICK_TO_UPLOAD_LOGO"
                      )}</p>
                  </>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <img
                      src={logo.preview}
                      alt="Footer Company Logo"
                      style={{
                        maxWidth: 260,
                        maxHeight: 90,
                        objectFit: "contain",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger mt-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeLogo();
                      }}
                    >
                      <FiTrash2 className="me-1" /> {getText("DELETE")}
                    </button>
                  </div>
                )}
              </div>

              <div className="text-center mt-4">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SettingFooterCompanyLogo;
